import React, { useState, useEffect } from 'react';
import Axios from '../../axios/axios';
import { useSelector, useDispatch } from 'react-redux';
import { ListProducts } from '../../actions/productAction';

export default function RentOutModal() {
  const dispatch = useDispatch();

  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  const [searchCustomer, setSearchCustomer] = useState('');
  const [customerError, setCustomerError] = useState('');
  const [selectedOrder, setOrderSelected] = useState('');
  const [orders, setOrders] = useState([]);
  const [product, setProduct] = useState('');
  const [date, setDate] = useState(getTodayDate());
  const [stock, setStock] = useState('');
  const [productList_, setProductList_] = useState([]);
  const [stocksList, setStockList] = useState([]);

  useEffect(() => {
    dispatch(ListProducts({ pagination: false }));
  }, [dispatch]);

  useEffect(() => {
    getProductList(selectedOrder);
  }, [selectedOrder]);

  const getProductList = (orderId) => {
    let data = orders?.find((lt) => lt._id === orderId);
    let orderItems = data?.orderItems;

    const matchingObjects = products?.filter((item1) =>
      orderItems?.some((item2) => item2.product === item1._id)
    );

    setProductList_(matchingObjects);
    // let productsList = products?.find((data)=>data)
  };

  const customerSearchFunction = async (e) => {
    let obj = {
      phone: parseInt(searchCustomer),
    };
    const { data } = await Axios.post(`/api/order/list`, obj);

    if (data?.data?.length === 0) {
      setCustomerError('No order found !');
    } else {
      setCustomerError(`${data?.data?.length} order found on this `);
      setOrders(data?.data);
    }
  };

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const changeProduct = (val) => {
    setProduct(val);
    getStockFormProduct(val);
  };

  const getStockFormProduct = async (id) => {
    await Axios.get(`/api/products/${id}`).then((res) => {
      setStockList(res?.data?.stock);
    });
  };

  const rentOutFnc = async (e) => {
    e.preventDefault();
    if (window.confirm('Are you sure')) {
      let obj = {
        orderId: selectedOrder,
        product,
        stock,
        date,
      };
      await Axios.post(`/api/order/rentout`, obj).then((res) => {
        if (res.data.status === 200) {
          window.location.href = `/order/${selectedOrder}`;
        }
      });
    }
  };

  return (
    <div
      class="modal fade"
      id="rentOutModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      backdrop={true}
      data-backdrop="static"
    >
      {' '}
      <form class="forms-sample" onSubmit={rentOutFnc}>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Rent Out
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="exampleInputName">Search Customer here</label>
                <div class="row">
                  <div class="col-10">
                    {' '}
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Search number here"
                      onChange={(e) => setSearchCustomer(e.target.value)}
                    />
                  </div>{' '}
                  <div class="col-2">
                    <i
                      className="icon-search mx-0 pointer"
                      onClick={customerSearchFunction}
                    ></i>
                  </div>
                  <div className="p-3"> {customerError}</div>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Order</label>
                <select
                  class="form-control"
                  onChange={(e) => setOrderSelected(e.target.value)}
                  value={selectedOrder}
                >
                  <option value="">Select Order</option>
                  {orders?.map((data) => (
                    <option value={data._id}>ADC_{data.orderId}</option>
                  ))}
                </select>
              </div>

              <div class="form-group">
                <label for="exampleInputName">Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setDate(e.target.value)}
                  required={true}
                  value={date}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Product</label>

                <select
                  className="form-control"
                  required={true}
                  onChange={(e) => changeProduct(e.target.value)}
                >
                  <option value="">Select Product</option>
                  {productList_?.map((data) => (
                    <option value={data._id}>{data.name}</option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Stock</label>
                <select
                  className="form-control"
                  required={true}
                  onChange={(e) => setStock(e.target.value)}
                >
                  <option value="">Select Stock</option>
                  {stocksList?.map((data) => (
                    <option value={data.itemCode}>{data.itemCode}</option>
                  ))}
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" class="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
